import React, { useEffect, useState } from "react";

import SubscriptionsTable from "subscriptions/components/SubscriptionsTable";
import SubscriptionsService from "subscriptions/api/SubscriptionsService";

import { Root, Summary, Block, Text, Digits } from "../styles";

const DeveloperOwner = ({ searchFilter }) => {
  const [summary, setSummary] = useState({
    activeSubscriptionsCount: 0,
  });

  const subscriberType = "DeveloperOwner";

  const fetchSummary = async () => {
    const {
      data: { data },
    } = await SubscriptionsService.getSummaryInfo(subscriberType);

    setSummary(data);
  };

  useEffect(() => {
    fetchSummary();
  }, []);

  return (
    <Root>
      <Summary>
        <Block widthPercentage="100%">
          <Text>Total Active Subscribers</Text>
          <Digits>{summary.activeSubscriptionsCount}</Digits>
        </Block>
      </Summary>
      <SubscriptionsTable
        searchFilter={searchFilter}
        subscriberType="DeveloperOwner"
      />
    </Root>
  );
};

export default DeveloperOwner;
